"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.role = void 0;

var _BooleanAsNumber = require("../../../../types/BooleanAsNumber");

var role = {
  id: {
    type: Number,
    field: 'Id',
    path: 'Id[0]'
  },
  name: {
    type: String,
    field: 'Name',
    path: 'Name[0]'
  },
  description: {
    type: String,
    field: 'Description',
    path: 'Description[0]'
  },
  dataHierarchyId: {
    type: Number,
    field: 'DataHierarchyId',
    path: 'DataHierarchyId[0]'
  },
  allowSelfAssign: {
    type: Boolean,
    field: 'AllowSelfAssign',
    path: 'AllowSelfAssign[0]'
  },
  displayName: {
    type: String,
    field: 'DisplayName',
    path: 'DisplayName[0]'
  },
  hide: {
    type: _BooleanAsNumber.BooleanAsNumber,
    field: 'Hide',
    path: 'Hide[0]'
  }
};
exports.role = role;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/authentication/models/role.js
// module id = 73
// module chunks = 0